import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { TerminalService } from '../../services/terminal.service';
import { GeneralService } from '../../services/general.service';
import { TerminalListener } from '../../interface/terminal-listener';
import { TerminalModel } from '../../interface/terminal-model';

@Component({
    selector: 'app-terminal',
    templateUrl: './terminal.component.html',
    styleUrls: ['./terminal.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})

export class TerminalComponent implements OnInit, OnDestroy {
    @Input() listener: TerminalListener;
    @Input() typeOperation: string;
    @Input() isAmenaEnCasa: boolean;
    public index: number;
    public brands: any[] = [];
    public terminalsFiltered: TerminalModel[] = [];
    public paymentTypes: any[] = [
        {id: 0, name: 'Pago a plazos'},
        {id: 1, name: 'Pago único'}
    ];
    public terminal: TerminalModel;
    public isKratos: boolean = false;
    public changeTerminal: boolean = false;
    public paymentType: string;
    public type = 'mobile';
    public errorForm = false;
    private terminals: TerminalModel[] = [];
    private filterPaymentType = -1;
    private filterBrand: string = null;
    private filterModel: string = null;
    public loaded: boolean = false;
    destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private modalService: NgbModal,
        protected terminalService: TerminalService,
        protected generalService: GeneralService,
    ) { }

    ngOnInit(): void {
        this.index = this.listener.getIndex();
        this.generalService.getEmptyFormMobilePack()
            .pipe(takeUntil(this.destroy$))
            .subscribe(data => {
                if (data != null && typeof data[this.index] !== 'undefined') {
                    const mobile = data[this.index];
                    this.terminal = mobile.terminal;
                    if (mobile.rate && mobile.rate.type === '4G') {
                        this.type = 'home';
                    }
                    this.typeOperation = mobile.type_operation;
                    if (mobile.terminal_payment_type !== null) {
                        this.paymentType = mobile.terminal_payment_type;
                        this.selectTerminalAndPayment(this.terminal,this.paymentType);
                    }

                }
            });
    }

    open(content) {
        this.loaded = false;
        this.changeTerminal = false;
        this.modalService.open(content, {size: 'xl', centered: true});
        this.terminalService.getTerminals(this.type)
            .subscribe((data: any) => {
                if (data.msg && data.msg.length && data.msg[0].payments) {
                    this.isKratos = true;
                    this.terminals = data.msg.filter(terminal => {
                        const found = terminal.payments.find(x => (this.typeOperation === 'registration_logistica' && x.order_type === 'new_order') || (this.typeOperation === 'registration' && x.order_type === 'new_order') || (this.typeOperation === 'portability_logistica' && x.order_type === 'portability') || (this.typeOperation === 'portability' && x.order_type === 'portability'));
                        if (found) {
                            return terminal;
                        }                
                    });
                } else {
                    this.isKratos = false;
                    this.terminals = data.msg;
                }
                this.terminalsFiltered = this.terminals;
                this.terminals.forEach((item) => {
                    if (item.brand !== null && !this.brands.includes(item.brand)) {
                        this.brands.push(item.brand);
                    }
                });
            }, () => {
                this.loaded = true;
            }, () => {
                this.loaded = true;
            });
    }

    selectFilterPaymentType(paymentType: any) {
        this.filterPaymentType = parseInt(paymentType, null);
        this.filter();
    }

    selectFilterBrand(brand: string) {
        this.filterBrand = brand;
        this.filter();
    }

    inputModel(model: string) {
        this.filterModel = model;
        this.filter();
    }

    filter() {
        this.terminalsFiltered = this.terminals.filter((item) => {
            let paymentTypeBool = true;
            const brandBool: boolean = this.filterBrand !== null ? item.brand.includes(this.filterBrand) : true;
            const modelBool: boolean = this.filterModel !== null ? item.name.toLowerCase().includes(this.filterModel.toLowerCase()) : true;

            if (this.isKratos) {
                const found = item.payments.find(x => (this.typeOperation === 'registration_logistica' && x.order_type === 'new_order') || (this.typeOperation === 'registration' && x.order_type === 'new_order') || (this.typeOperation === 'portability_logistica' && x.order_type === 'portability') || (this.typeOperation === 'portability' && x.order_type === 'portability'));
                if (found) {
                    if (this.filterPaymentType === 0) {
                        paymentTypeBool = +found.payment_quota > 0;
                    } else if (this.filterPaymentType === 1) {
                        paymentTypeBool = +found.price > 0;
                    }
                }
            } else {
                if (this.filterPaymentType === 0) {
                    paymentTypeBool = item.payment_quota > 0;
                } else if (this.filterPaymentType === 1) {
                    paymentTypeBool = item.price > 0;
                }
            }

            return paymentTypeBool && brandBool && modelBool;
        });
    }

    selectPaymentType(type: string) {
        this.paymentType = type;
        this.errorForm = false;
        this.listener.onSelectTerminal(this.terminal, this.paymentType);
        this.modalService.dismissAll();
    }

    selectTerminalAndPayment(terminal, paymentType) {
        this.terminal = terminal;
        this.paymentType = paymentType;
        if (this.isKratos) {
            const found = terminal.payments.find(x => (this.typeOperation === 'registration_logistica' && x.order_type === 'new_order') || (this.typeOperation === 'registration' && x.order_type === 'new_order') || (this.typeOperation === 'portability_logistica' && x.order_type === 'portability') || (this.typeOperation === 'portability' && x.order_type === 'portability'));
            if (found) {
                this.terminal.price = found.price;
                this.terminal.initial_payment = found.initial_payment;
                this.terminal.payment_quota = found.payment_quota;
                this.terminal.payment_months = found.payment_months;
            }
        }        
        this.errorForm = false;
        this.listener.onSelectTerminal(this.terminal, this.paymentType);
        this.modalService.dismissAll();
    }

    removeSelectedTerminal() {
        this.terminal = null;
        this.paymentType = null;
        this.listener.onDeleteTerminal();
    }

    changeTypeOperation(typeOperation) {
        this.typeOperation = typeOperation;

        if (this.terminal && this.terminal.payments) {
            const found = this.terminal.payments.find(x => (this.typeOperation === 'registration_logistica' && x.order_type === 'new_order') || (this.typeOperation === 'registration' && x.order_type === 'new_order') || (this.typeOperation === 'portability_logistica' && x.order_type === 'portability') || (this.typeOperation === 'portability' && x.order_type === 'portability'));
            if (found) {
                if (this.paymentType === 'VAP' && +found.payment_quota === 0) {
                    this.changeTerminal = true;
                    this.removeSelectedTerminal();
                }
            } else {
                this.changeTerminal = true;
                this.removeSelectedTerminal();
            }
        } else {
            if (this.terminal && this.paymentType === 'VAP' && this.typeOperation === 'registration') {
                this.removeSelectedTerminal();
            }
        }
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
